import React from 'react';
import { shape, string } from 'prop-types';
import { Container, Grid } from '@material-ui/core';
import SingleCasePage from '../../templates/SingleCasePage';
import data from '../../data/cases/abilia';
import InfoColumnSection from '../../components/InfoColumnSection';
import TitleAndBodySection from '../../components/case/TitleAndBodySection';
import ContainerNoFrame from '../../components/case/ContainerNoFrame';
import SingleImage from '../../components/case/SingleImage';
import DoubleImage from '../../components/case/DoubleImage';
import variables from '../../styles/variables.module.scss';

const nextCase = null;

const AbiliaCasePage = ({ location }) => (
  <SingleCasePage
    location={location}
    caseName={data.key}
    data={data}
    nextCase={nextCase}
    quoteData={data.quoteData}
    alignHeroImage="center"
    coverHero
  >
    <Container>
      <Grid container direction="column">
        {
          data.titleBodyData[0] && (
            <TitleAndBodySection
              title={data.titleBodyData[0].title}
              body={data.titleBodyData[0].body}
              justify={data.titleBodyData[1] ? 'flex-end' : 'flex-start'}
            />
          )
        }
        {
          data.environmentFirst && (
            <SingleImage
              image={data.environmentFirst}
              isAndroid={data.isAndroid}
              insideGrid={data.environmentFirst.insideGrid}
            />
          )
        }
      </Grid>
    </Container>
    {
      data.environments && (
      <DoubleImage
        imageLeft={data.environments.env1}
        imageRight={data.environments.env2}
      />
      )
    }
    {
      data.env1 && (
        <SingleImage
          image={data.env1}
          insideGrid
          style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
        />
      )
    }
    {
      data.titleBodyData[1] && (
        <TitleAndBodySection
          title={data.titleBodyData[1].title}
          body={data.titleBodyData[1].body}
        />
      )
    }
    {
      data.xtra && (
        <ContainerNoFrame images={data.xtra} />
      )
    }
    {
      data.infoTitle && data.infoBody && (
        <Grid item>
          <InfoColumnSection
            headlineSmall={data.title}
            backgroundColor={variables.carbonBlack}
            title={data.infoTitle}
            body={data.infoBody}
            isCase
            // data={data.infoData}
          />
        </Grid>
      )
    }
    {
      data.footerBanner && (
        <SingleImage
          image={data.footerBanner}
          style={{ width: '100%', margin: 0 }}
        />
      )
    }
  </SingleCasePage>
);

AbiliaCasePage.propTypes = {
  location: shape({
    pathname: string,
  }).isRequired,
};

export default AbiliaCasePage;
